import * as yup from 'yup';

import billUploadGenericErrorImg from '../../../../assets/images/bill_upload_generic_error.svg';
import billUploadRequiresEAImg from '../../../../assets/images/bill_upload_requires_ea.svg';
import billUploadSuccessImg from '../../../../assets/images/bill_upload_success.svg';
import billUploadUnsupportedErrorImg from '../../../../assets/images/bill_upload_unsupported_error.svg';

export const manualBillUploadSchema = yup.object({
  retailerId: yup.number().nullable().required('Retailer is required'),
  startDate: yup.date().nullable().required('Start date is required'),
  endDate: yup
    .date()
    .nullable()
    .required('End date is required')
    .max(new Date(), 'End date cannot be in the future')
    .when('startDate', (startDate: Date | null | undefined, schema: yup.DateSchema<Date | null | undefined>) => {
      return schema.test('end-before-start', 'End date cannot be before start date', function (endDate) {
        if (!startDate || !endDate) return true;
        return startDate <= endDate;
      });
    }),
  totalAmount: yup
    .number()
    .transform((value, originalValue) => {
      return originalValue === '' ? null : value;
    })
    .nullable()
    .required('Total amount is required'),
  billS3Path: yup.string().nullable().required('Bill S3 path is required'),
});

export enum BillUploadStatus {
  InProgressPreSigning,
  InProgressUploading,
  InProgressProcessing,
  Success,
  SuccessHistorical,
  TentativeFail,
  FailUnsupported,
  FailGeneric,
}

export type UploadDialogConfig = {
  icon: string;
  buttonText: string;
  messageText: {
    heading: string;
    body: string;
  };
};

export const BILL_STATUS_TO_CONFIG: Record<BillUploadStatus, UploadDialogConfig> = {
  [BillUploadStatus.InProgressPreSigning]: {
    icon: '',
    buttonText: '',
    messageText: {
      heading: '',
      body: 'Preparing your upload...',
    },
  },
  [BillUploadStatus.InProgressUploading]: {
    icon: '',
    buttonText: '',
    messageText: {
      heading: '',
      body: 'Uploading your bill to our servers...',
    },
  },
  [BillUploadStatus.InProgressProcessing]: {
    icon: '',
    buttonText: '',
    messageText: {
      heading: '',
      body: 'Processing your retail plan check...',
    },
  },
  [BillUploadStatus.Success]: {
    icon: billUploadSuccessImg,
    buttonText: 'View Plans',
    messageText: {
      heading: 'Your results are ready',
      body: 'Tap below to find the right energy plans and get saving more!',
    },
  },
  [BillUploadStatus.SuccessHistorical]: {
    icon: billUploadSuccessImg,
    buttonText: 'Back to bills',
    messageText: {
      heading: 'Your bill has been uploaded',
      body: "It looks like that was an old bill, so you won't see an updated retail plan check.",
    },
  },
  [BillUploadStatus.TentativeFail]: {
    icon: billUploadRequiresEAImg,
    buttonText: 'Done',
    messageText: {
      heading: 'Your bill needs to be reviewed by our team',
      //eslint-disable-next-line max-len
      body: 'Your bill has been received and requires a manual review by our team. Please expect it to appear in your bills page within the next 7 days. There is no need to upload it again.',
    },
  },
  [BillUploadStatus.FailUnsupported]: {
    icon: billUploadUnsupportedErrorImg,
    buttonText: 'Upload Bill',
    messageText: {
      heading: "This bill isn't supported",
      //eslint-disable-next-line max-len
      body: "It looks like you've uploaded an older bill or an unsupported bill type. Please try again with a different electricity bill.",
    },
  },
  [BillUploadStatus.FailGeneric]: {
    icon: billUploadGenericErrorImg,
    buttonText: 'Upload Bill',
    messageText: {
      heading: 'Oops! something went wrong',
      body: 'We had trouble uploading your bill. Please try again.',
    },
  },
};
